import type { LocalStorageInterface } from "./LocalStorageInterface"

export class LocalStorageController implements LocalStorageInterface {
    private fallbackStorage = new Map<string, string>()

    private get storage(): Storage | null {
        if (typeof window === "undefined") {
            return null
        }
        try {
            return window.localStorage
        } catch {
            return null
        }
    }

    getItem(key: string): string | null {
        const storage = this.storage
        if (storage) {
            return storage.getItem(key)
        }
        return this.fallbackStorage.get(key) ?? null
    }

    setItem(key: string, value: string): void {
        const storage = this.storage
        if (storage) {
            storage.setItem(key, value)
            return
        }
        this.fallbackStorage.set(key, value)
    }

    removeItem(key: string): void {
        const storage = this.storage
        if (storage) {
            storage.removeItem(key)
            return
        }
        this.fallbackStorage.delete(key)
    }
}
